import React from 'react'
import { FaWhatsapp, FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/all'
import {
    FacebookIcon,
    FacebookShareButton,
    WhatsappShareButton,
    TwitterShareButton,
    LinkedinShareButton,
} from 'react-share';
/**
* @author
* @function FullWidthContent
**/

const FullWidthContent = (props) => {
    const message = "Sharing  this site link in your respective collage graups / instagram / facebook story will connect students on the same site. You can share site link by ckicking on buttons mentioned below. Please Support us by sharing it to your contacts and groups."
    const message1 = ` 📢 *Announcement* 📢
	We are very excited 📢 to announce that, we have finally made something
to solve our small problem. 🤔 by  understanding current situation. Hope you will relate to it. We have developed a web based application💻 so, we called it BooksSky.

*What is BooksSky ??*

          BooksSky is web based application where you can list your books 📚, used books, PDFs, Notes📓, Handwriting Notes📝, Printed notes, Tuition Notes, and all type of study material related to academics for sell or Exchange 💱.  And connect other students 👨‍🎓 (for exchange/purchase) through their social media. We try to used social media in very effective way.

*We known what is purchasing/ selling , but what is Exchange of book ??*

         Exchange is nothing but as name suggests we have provided an Exchangement option  on the site. You can easily exchange numbers of books with other student.
So you can read numbers of books without paying a single rupee💲.

So , That’s all.🙂

       Obviously, this site contains limited features till now😌. So if you think this site is really helping to you and want to some more features suppose to in it, then please!! we request to all GCOEYian provide honest feedback to us for improving ourselves and we will definitely work on it to add more features in it.


       Our humble request🙏 to all  GCOEYian please share this message in your all respective contacts and group (related to academics). Invite your friends on this site for  connect more and more student.

  If you have any issues or suggestion while using the BooksSky you can fill the feedback form or you can contact us on social media handles.  We will modify it with respect to time.


Explore :- https://www.bookssky.in



*Hope this will help us*`
    return (
        <section className="  FullWidth flex flex-jc-c flex-ai-c">
            <h1 className="heading">Support Us</h1>
            <p className="text-content">
                {message}
            </p>
            <div className="social__icons flex">
                <a href={`https://api.whatsapp.com/send?text=${message1}`} data-action="share/whatsapp/share" target="_blank" >.<FaWhatsapp color="green" />
                </a>
                <a target="_blank">
                    <FacebookShareButton
                        url={`bookssky.in`}
                        quote={message1}>
                        <FaFacebook color="#4267B2" />
                    </FacebookShareButton>
                </a>
                <a target="_blank">
                    <TwitterShareButton
                        url={`bookssky.in`}
                        title={message1}>
                        <FaTwitter color="#1DA1F2" />
                    </TwitterShareButton>
                </a>
                <a target="_blank">
                    <LinkedinShareButton
                        url={`bookssky.in`}
                        summary={message1}>
                        <FaLinkedin color="#0077b5" />
                    </LinkedinShareButton>
                </a>
            </div>
        </section>
    )
}


export default FullWidthContent;